function sanitizeFileStemSegment(value: string): string {
  const trimmed = value.trim().replace(/\.pdf$/iu, "");
  const sanitized = Array.from(trimmed)
    .map((character) => {
      if (character < " " || /[<>:"/\\|?*]/.test(character)) {
        return " ";
      }
      return character;
    })
    .join("")
    .replace(/\s+/g, " ")
    .trim();

  return sanitized;
}

export function buildRunReportFileName(options: {
  kind: "fatture_ddt" | "polizza_carico";
  runId: number;
  originalFilename: string | null | undefined;
}): string {
  const sanitizedStem = options.originalFilename
    ? sanitizeFileStemSegment(options.originalFilename)
    : "";
  const kindLabel =
    options.kind === "fatture_ddt" ? "fatture-ddt" : "polizza-carico";

  if (!sanitizedStem) {
    return `report ${kindLabel} #${options.runId}.pdf`;
  }

  return `${sanitizedStem} - report ${kindLabel} #${options.runId}.pdf`;
}
